import { render, staticRenderFns } from "./ScenarioPractices.vue?vue&type=template&id=d55b3286&scoped=true&"
import script from "./ScenarioPractices.vue?vue&type=script&lang=js&"
export * from "./ScenarioPractices.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioPractices.vue?vue&type=style&index=0&id=d55b3286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55b3286",
  null
  
)

export default component.exports